/**
 * Mask email or any string: show first half, replace second half with *****.
 * @param {string} str - Email or string to mask
 * @returns {string} Masked string, or '-' if empty
 */
export function maskEmail(str) {
  if (str == null || typeof str !== 'string') return '-';
  const trimmed = str.trim();
  if (trimmed.length === 0) return '-';
  const half = Math.floor(trimmed.length / 2);
  return half <= 0 ? '*****' : trimmed.slice(0, half) + '*****';
}

/**
 * Plain email when API returns decrypted `email`; otherwise masked `encrypted_email`.
 * @param {object|null|undefined} user
 * @returns {string}
 */
export function displayUserEmail(user) {
  if (!user || typeof user !== 'object') return '-';
  const plain = user.email ?? user.Email;
  if (plain != null && String(plain).trim() !== '') return String(plain).trim();
  return maskEmail(user.encrypted_email ?? user.EncryptedEmail);
}

/** Datetime for admin tables (ISO string → space, trim to seconds). */
export function formatDateTime(value) {
  if (value == null || value === '') return '-';
  if (typeof value !== 'string') return String(value);
  return value.replace('T', ' ').slice(0, 19);
}
